/* eslint-disable camelcase, @typescript-eslint/naming-convention */
import React from 'react';
import { MarkdownText } from '../../../molecules/MarkdownText';
import './MarkdownRendererStyles.scss';
const baseClass = 'qmb-ui-markdown-renderer';
export function MarkdownRenderer({ block }) {
    const { content, streaming } = block;
    return (React.createElement("div", { className: baseClass },
        React.createElement(MarkdownText, { content: content, streaming: streaming })));
}
